export default __webpack_public_path__ + "static/media/logo_pszczyna.81a5209a.jpg";